module.exports = __webpack_public_path__ + "icon-surface-galvanised.png?246217f4014602b89e5b3aac9bc6e2f4";